import Svg, { SvgProps } from './Svg';

export default function ExternalLinkIcon({
  color = 'currentColor',
  ...props
}: SvgProps) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      {...props}>
      <path
        d="M8.23145 2.77051C8.23145 2.35629 8.56723 2.02051 8.98145 2.02051L13.9815 2.02051L13.9815 7.02057C13.9815 7.43478 13.6457 7.77057 13.2315 7.77057C12.8173 7.77057 12.4815 7.43478 12.4815 7.02057L12.8439 4.21873L7.30035 9.76228C7.00746 10.0552 6.53258 10.0552 6.23969 9.76228C5.9468 9.46939 5.9468 8.99451 6.23969 8.70162L11.7832 3.15808L8.98145 3.52051C8.56723 3.52051 8.23145 3.18472 8.23145 2.77051Z"
        fill={color}
      />
      <path
        d="M2.02148 3.77051C2.02148 3.35629 2.35727 3.02051 2.77148 3.02051L6.25763 3.02051C6.67185 3.02051 7.00763 3.35629 7.00763 3.77051C7.00763 4.18472 6.67185 4.52051 6.25763 4.52051L3.52148 4.52051L3.52148 12.4805L11.4814 12.4805L11.4814 9.75409C11.4814 9.33988 11.8172 9.00409 12.2314 9.00409C12.6457 9.00409 12.9814 9.33988 12.9814 9.75409V13.2305C12.9814 13.6447 12.6457 13.9805 12.2314 13.9805L2.77148 13.9805C2.35727 13.9805 2.02148 13.6447 2.02148 13.2305L2.02148 3.77051Z"
        fill={color}
      />
    </Svg>
  );
}
